import axios from 'axios'
import config from '../config'
import {
  formatCurrency as fc,
  formatModifiedTicker,
  getModifiedTicker,
} from './StylesHelper'
import { getImageUrl } from './StylesHelper'
import { getChangePercentageColor } from './MarketsHelper'
import VerifiedIcon from '../components/VerifiedIcon'
import React, { useState } from 'react'
import { followUser } from './ProfileHelper'

export const fetchBestUsers = async (
  timePeriod,
  sortBy = '%return',
  page = 1,
  limit = 5,
  setLeaderboardData,
  filter = 'all',
  searchQuery = '',
  asc = false,
  userToken = null
) => {
  try {
    const response = await axios.get(
      `${config.LBbackendUrl}/api/portfolios/top-portfolios-v1`,
      {
        params: {
          timePeriod,
          sortBy,
          page,
          limit,
          filter,
          searchQuery,
          asc,
        },
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      }
    )

    // console.log('top-port: ',response.data.data)
    setLeaderboardData(response.data)
  } catch (error) {
    console.error('Error fetching leaderboard data:', error)
  }
}

export const fetchBestLeaderboards = async (
  timePeriod = 'Today',
  sortBy = '%return',
  type = 'all',
  page = 1,
  limit = 10,
  setLeaderboardData,
  parentLeaderboard = null,
  searchQuery = '',
  asc = false,
  userToken = null
) => {
  try {
    const response = await axios.get(
      `${config.LBbackendUrl}/api/leaderboards/top-leaderboards`,
      {
        params: {
          timePeriod,
          sortBy,
          page,
          limit,
          parentLeaderboard,
          searchQuery,
          type,
          asc,
        },
        headers: {
          Authorization: userToken ? `Bearer ${userToken}` : '',
        },
      }
    )

    setLeaderboardData(response.data)
  } catch (error) {
    console.error('Error fetching top leaderboards:', error)
  }
}

export async function handleJoinOrLeaveLeaderboard(
  leaderboardId,
  userToken,
  isMember,
  onSuccess,
  onError
) {
  try {
    // Attempt to join the leaderboard
    await axios.post(
      `${config.backendUrl}/api/leaderboards/${leaderboardId}/${
        isMember ? 'leave' : 'join'
      }`,
      {},
      { headers: { Authorization: `Bearer ${userToken}` } }
    )
    // If successful, call the onSuccess callback
    if (typeof onSuccess === 'function') {
      onSuccess()
    }
  } catch (error) {
    console.error('Error joining leaderboard:', error)
    // Optionally call onError
    if (typeof onError === 'function') {
      onError(error)
    }
  }
}

export const sortOptions = [
  { value: '%return', label: 'Best % Returns', asc: false },
  { value: '%return', label: 'Worst % Returns', asc: true },
  { value: 'netReturn', label: 'Best Net Returns', asc: false },
  { value: 'netReturn', label: 'Worst Net Returns', asc: true },
]

// export function LeaderboardCardUser({
//   topPortfolio,
//   index,
//   selectedSortOption,
//   navigate,
//   tc,
//   currentUserId,
//   userToken,
// }) {
//   const { user, percentageGain, netGain, largestPositionTicker } = topPortfolio

//   // State to track hover and follow status
//   const [isHovered, setIsHovered] = useState(false)
//   const [isFollowing, setIsFollowing] = useState(
//     topPortfolio?.user?.isFollowing || false
//   )
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

//   let userId = user.id || user._id

//   // e.stopPropagation() prevents the card's onClick from triggering
//   const handleFollowClick = async (e) => {
//     e.stopPropagation()
//     const newStatus = await followUser(currentUserId, userId, userToken) //user.id || user._id is a workaround for different API responses
//     setIsFollowing(newStatus)
//   }

//   return (
//     <div className="LeadCardMobile">
//       <div
//         className="LeadCard"
//         onClick={() => navigate(`/profile/${user.username}`)}
//         onMouseEnter={() => setIsHovered(true)}
//         onMouseLeave={() => setIsHovered(false)}
//       >
//         <div
//           style={{ color: index === 0 ? '#FFBF19' : 'inherit' }}
//           className="LeadCardRank"
//         >
//           {index + 1}
//         </div>

//         <div
//           className="LeadCardImageWrapper"
//           style={{
//             boxShadow:
//               index === 0 ? '0 0 0.6rem #030902, 0 0 1rem #FFBF19' : 'none',
//             position: 'relative',
//           }}
//         >
//           <img
//             src={getImageUrl(user.profilePicture)}
//             alt={user.name}
//             className="LeadCardImage"
//           />

//           {/* FOLLOW BUTTON ON HOVER */}
//           <button
//             className={`LeadFollowButton ${isHovered ? 'bold' : ''}`}
//             onClick={handleFollowClick}
//             style={{
//               backgroundColor:
//                 index === 0 ? '#FFBF19' : 'var(--stock-change-pos)',
//             }}
//           >
//             {isFollowing ? 'Following' : 'Follow'}
//           </button>
//         </div>
//         <div className="LeadCardUser">
//           <div>
//             <h3 className="LeadCardName">
//               {user.name}{' '}
//               {user.isUserVerified && (
//                 <VerifiedIcon
//                   color={index === 0 ? '#FFBF19' : 'var(--stock-change-pos)'}
//                   fontSize="1.3rem"
//                 />
//               )}
//             </h3>
//             <div
//               className="LeadCardGain bold"
//               style={{
//                 color:
//                   index === 0
//                     ? '#FFBF19'
//                     : getChangePercentageColor(percentageGain, tc()),
//               }}
//             >
//               {selectedSortOption === '%return' ? (
//                 <>
//                   <span className="LeadGainArrow">
//                     {percentageGain >= 0 ? '↑' : '↓'}
//                   </span>
//                   {fc(percentageGain, 2, true)}%
//                 </>
//               ) : (
//                 <>
//                   <span className="LeadGainArrow">
//                     {netGain >= 0 ? '↑' : '↓'}
//                   </span>
//                   ${fc(netGain, 2, true)}
//                 </>
//               )}
//             </div>
//           </div>

//           <div className="LeadCardLargestPosition">
//             <h3
//               className="LeadCardName"
//               style={{ color: 'var(--action-grey)' }}
//             >
//               Largest Position
//             </h3>
//             <span
//               style={{ color: index === 0 ? '#FFBF19' : 'var(--text-color)' }}
//               className="bold"
//             >
//               {formatModifiedTicker(largestPositionTicker) || '--'}
//             </span>
//           </div>
//         </div>
//       </div>
//       {isMobile && (
//         <div className="LeadCardFollowButton">
//           <button
//             className={`CreatePostFeedButton ${isHovered ? 'bold' : ''}`}
//             onClick={handleFollowClick}
//           >
//             {isFollowing ? 'Following' : 'Follow'}
//           </button>
//         </div>
//       )}
//     </div>
//   )
// }

// export function LeaderboardCardLeaderboard({
//   topLeaderboard,
//   index,
//   selectedSortOption,
//   navigate,
//   tc,
//   userToken,
// }) {
//   const [isHovered, setIsHovered] = useState(false)

//   // Local membership state (so we can toggle button text/UI immediately)
//   const [isMember, setIsMember] = useState(topLeaderboard?.isMember || false)

//   // Extract fields for readability
//   const { leaderboardId, username, isLeaderboardVerified } = topLeaderboard
//   const { percentageGain, netGain, totalMembers, profileImage, name } =
//     topLeaderboard
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

//   // Called when user clicks "Join" or "Leave"
//   const handleJoinOrLeaveClick = (e) => {
//     e.stopPropagation() // Prevent card navigation
//     handleJoinOrLeaveLeaderboard(
//       leaderboardId,
//       userToken,
//       isMember, // Are they currently a member?
//       // onSuccess callback
//       () => {
//         // Flip membership state
//         setIsMember((prev) => !prev)
//       },
//       // onError callback
//       (error) => {
//         console.error('Error joining/leaving leaderboard:', error)
//         alert(error?.response?.data?.error || 'Error updating membership')
//       }
//     )
//   }

//   // Determine which numeric field is displayed
//   const fieldValue = selectedSortOption === '%return' ? percentageGain : netGain
//   const arrow = fieldValue >= 0 ? '↑' : '↓'
//   const arrowColor =
//     index === 0 ? '#FFBF19' : getChangePercentageColor(fieldValue, tc())

//   return (
//     <div
//       className="LeadCard"
//       style={{ position: 'relative' }}
//       onMouseEnter={() => setIsHovered(true)}
//       onMouseLeave={() => setIsHovered(false)}
//       onClick={() => navigate(`/leaderboard/${username}`)}
//     >
//       <div
//         style={{ color: index === 0 ? '#FFBF19' : 'inherit' }}
//         className="LeadCardRank"
//       >
//         {index + 1}
//       </div>
//       <div
//         className="LeadCardImageWrapper LeaderRadius"
//         style={{
//           boxShadow:
//             index === 0 ? '0 0 0.6rem #030902, 0 0 1rem #FFBF19' : 'none',
//           position: 'relative',
//         }}
//       >
//         <img
//           src={getImageUrl(profileImage)}
//           alt={name}
//           className="LeadCardImage"
//         />

//         {/* Only show button on hover */}
//         {isHovered && (
//           <button
//             className={`LeadFollowButton ${isHovered ? 'bold' : ''}`}
//             onClick={handleJoinOrLeaveClick}
//             style={{
//               backgroundColor:
//                 index === 0 ? '#FFBF19' : 'var(--stock-change-pos)',
//             }}
//           >
//             {isMember ? 'Leave' : 'Join'}
//           </button>
//         )}
//       </div>
//       <div className="LeadCardUser">
//         <div>
//           <h3 className="LeadCardName">
//             {name}{' '}
//             {isLeaderboardVerified && (
//               <VerifiedIcon
//                 fontSize="1.3rem"
//                 color={index === 0 ? '#FFBF19' : 'var(--stock-change-pos)'}
//               />
//             )}
//           </h3>
//           <div
//             className="LeadCardGain bold"
//             style={{
//               color:
//                 index === 0
//                   ? '#FFBF19'
//                   : getChangePercentageColor(fieldValue, tc()),
//             }}
//           >
//             {selectedSortOption === '%return' ? (
//               <>
//                 <span className="LeadGainArrow">{arrow}</span>
//                 {fc(fieldValue, 2, true)}%
//               </>
//             ) : (
//               <>
//                 <span className="LeadGainArrow">{arrow}</span>$
//                 {fc(fieldValue, 2, true)}
//               </>
//             )}
//           </div>
//         </div>

//         <div className="LeadCardLargestPosition">
//           <h3 className="LeadCardName" style={{ color: 'var(--action-grey)' }}>
//             {fc(totalMembers, 0)} members
//           </h3>
//         </div>
//       </div>
//       {isMobile && (
//         <div className="LeadCardJoinButton">
//           <button
//             className={`CreatePostFeedButton  ${isHovered ? 'bold' : ''}`}
//             onClick={handleJoinOrLeaveClick}
//           >
//             {isMember ? 'Leave' : 'Join'}
//           </button>
//         </div>
//       )}
//     </div>
//   )
// }

// Optimized LeaderboardCardUser
export const LeaderboardCardUser = React.memo(
  ({
    topPortfolio,
    index,
    selectedSortOption,
    navigate,
    tc,
    currentUserId,
    userToken,
  }) => {
    const { user, percentageGain, netGain, largestPositionTicker } =
      topPortfolio
    const [isHovered, setIsHovered] = useState(false)
    const [isFollowing, setIsFollowing] = useState(
      topPortfolio?.user?.isFollowing || false
    )
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
    const userId = user.id || user._id

    const handleFollowClick = async (e) => {
      e.stopPropagation()
      const newStatus = await followUser(currentUserId, userId, userToken)
      setIsFollowing(newStatus)
    }

    return (
      <div className="LeadCardMobile">
        <div
          className="LeadCard"
          onClick={() => navigate(`/profile/${user.username}`)}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div
            className="LeadCardRank"
            style={{ color: index === 0 ? '#FFBF19' : 'inherit' }}
          >
            {index + 1}
          </div>
          <div
            className="LeadCardImageWrapper"
            style={{
              boxShadow:
                index === 0 ? '0 0 0.6rem #030902, 0 0 1rem #FFBF19' : 'none',
              position: 'relative',
            }}
          >
            <img
              src={getImageUrl(user.profilePicture)}
              alt={user.name}
              className="LeadCardImage"
            />
            <button
              className={`LeadFollowButton ${isHovered ? 'bold' : ''}`}
              onClick={handleFollowClick}
              style={{
                backgroundColor:
                  index === 0 ? '#FFBF19' : 'var(--stock-change-pos)',
              }}
            >
              {isFollowing ? 'Following' : 'Follow'}
            </button>
          </div>
          <div className="LeadCardUser">
            <div>
              <h3 className="LeadCardName">
                {user.name}
                {user.isUserVerified && (
                  <VerifiedIcon
                    fontSize="1.3rem"
                    color={index === 0 ? '#FFBF19' : 'var(--stock-change-pos)'}
                  />
                )}
              </h3>
              <div
                className="LeadCardGain bold"
                style={{
                  color:
                    index === 0
                      ? '#FFBF19'
                      : getChangePercentageColor(percentageGain, tc()),
                }}
              >
                {selectedSortOption === '%return' ? (
                  <>
                    <span className="LeadGainArrow">
                      {percentageGain >= 0 ? '↑' : '↓'}
                    </span>
                    {fc(percentageGain, 2, true)}%
                  </>
                ) : (
                  <>
                    <span className="LeadGainArrow">
                      {netGain >= 0 ? '↑' : '↓'}
                    </span>
                    ${fc(netGain, 2, true)}
                  </>
                )}
              </div>
            </div>
            <div className="LeadCardLargestPosition">
              <h3
                className="LeadCardName"
                style={{ color: 'var(--action-grey)' }}
              >
                Largest Position
              </h3>
              <span
                className="bold"
                style={{ color: index === 0 ? '#FFBF19' : 'var(--text-color)' }}
              >
                {formatModifiedTicker(largestPositionTicker) || '--'}
              </span>
            </div>
          </div>
        </div>
        {isMobile && (
          <div className="LeadCardFollowButton">
            <button
              className={`CreatePostFeedButton ${isHovered ? 'bold' : ''}`}
              onClick={handleFollowClick}
            >
              {isFollowing ? 'Following' : 'Follow'}
            </button>
          </div>
        )}
      </div>
    )
  },
  (prevProps, nextProps) =>
    prevProps.topPortfolio === nextProps.topPortfolio &&
    prevProps.isFollowing === nextProps.isFollowing
)

// Optimized LeaderboardCardLeaderboard
export const LeaderboardCardLeaderboard = React.memo(
  ({ topLeaderboard, index, selectedSortOption, navigate, tc, userToken }) => {
    const [isHovered, setIsHovered] = useState(false)
    const [isMember, setIsMember] = useState(topLeaderboard?.isMember || false)
    const {
      leaderboardId,
      username,
      isLeaderboardVerified,
      percentageGain,
      netGain,
      totalMembers,
      profileImage,
      name,
    } = topLeaderboard
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

    const handleJoinOrLeaveClick = (e) => {
      e.stopPropagation()
      handleJoinOrLeaveLeaderboard(
        leaderboardId,
        userToken,
        isMember,
        () => setIsMember((prev) => !prev),
        (error) => {
          console.error('Error joining/leaving leaderboard:', error)
          alert(error?.response?.data?.error || 'Error updating membership')
        }
      )
    }

    const fieldValue =
      selectedSortOption === '%return' ? percentageGain : netGain
    const arrow = fieldValue >= 0 ? '↑' : '↓'
    const arrowColor =
      index === 0 ? '#FFBF19' : getChangePercentageColor(fieldValue, tc())

    return (
      <div
        className="LeadCard"
        style={{ position: 'relative' }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={() => navigate(`/leaderboard/${username}`)}
      >
        <div
          className="LeadCardRank"
          style={{ color: index === 0 ? '#FFBF19' : 'inherit' }}
        >
          {index + 1}
        </div>
        <div
          className="LeadCardImageWrapper LeaderRadius"
          style={{
            boxShadow:
              index === 0 ? '0 0 0.6rem #030902, 0 0 1rem #FFBF19' : 'none',
            position: 'relative',
          }}
        >
          <img
            src={getImageUrl(profileImage)}
            alt={name}
            className="LeadCardImage"
          />
          {isHovered && (
            <button
              className={`LeadFollowButton ${isHovered ? 'bold' : ''}`}
              onClick={handleJoinOrLeaveClick}
              style={{
                backgroundColor:
                  index === 0 ? '#FFBF19' : 'var(--stock-change-pos)',
              }}
            >
              {isMember ? 'Leave' : 'Join'}
            </button>
          )}
        </div>
        <div className="LeadCardUser">
          <div>
            <h3 className="LeadCardName">
              {name}{' '}
              {isLeaderboardVerified && (
                <VerifiedIcon
                  fontSize="1.3rem"
                  color={index === 0 ? '#FFBF19' : 'var(--stock-change-pos)'}
                />
              )}
            </h3>
            <div
              className="LeadCardGain bold"
              style={{
                color:
                  index === 0
                    ? '#FFBF19'
                    : getChangePercentageColor(fieldValue, tc()),
              }}
            >
              {selectedSortOption === '%return' ? (
                <>
                  <span className="LeadGainArrow">{arrow}</span>
                  {fc(fieldValue, 2, true)}%
                </>
              ) : (
                <>
                  <span className="LeadGainArrow">{arrow}</span>$
                  {fc(fieldValue, 2, true)}
                </>
              )}
            </div>
          </div>
          <div className="LeadCardLargestPosition">
            <h3
              className="LeadCardName"
              style={{ color: 'var(--action-grey)' }}
            >
              {fc(totalMembers, 0)} members
            </h3>
          </div>
        </div>
        {isMobile && (
          <div className="LeadCardJoinButton">
            <button
              className={`CreatePostFeedButton ${isHovered ? 'bold' : ''}`}
              onClick={handleJoinOrLeaveClick}
            >
              {isMember ? 'Leave' : 'Join'}
            </button>
          </div>
        )}
      </div>
    )
  },
  (prevProps, nextProps) =>
    prevProps.topLeaderboard === nextProps.topLeaderboard &&
    prevProps.isMember === nextProps.isMember
)

export const handleToggleVerificationLeaderboard = async (
  leaderboardIdToVerify,
  userToken,
  callback = null
) => {
  if (
    !window.confirm(
      'Are you sure you want to verify/unverify this leaderboard?'
    )
  ) {
    return
  }

  try {
    const response = await axios.put(
      `${config.backendUrl}/api/leaderboards/verify-leaderboard`,
      { leaderboardIdToVerify: leaderboardIdToVerify },
      { headers: { Authorization: `Bearer ${userToken}` } }
    )

    // Optionally call any callback passed in
    if (typeof callback === 'function') {
      callback(response.data)
    }

    // For a simple user experience, you might display a message or refresh data:
    alert(response.data.message)
  } catch (error) {
    console.error('Error verifying leaderboard:', error)
    alert('Error verifying leaderboard, please check console.')
  }
}

export const handleDeleteLeaderboard = async (
  leaderboardIdToDelete,
  userToken,
  callback = null
) => {
  const confirmed = window.confirm(
    'Are you sure you want to delete this leaderboard?\nThis action cannot be undone.'
  )
  if (!confirmed) return

  try {
    const response = await axios.delete(
      `${config.backendUrl}/api/leaderboards/${leaderboardIdToDelete}`,
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      }
    )

    // Call the callback if provided
    if (typeof callback === 'function') {
      callback(response.data)
    }

    alert(response.data.message || 'Leaderboard deleted successfully!')
  } catch (error) {
    console.error('Error deleting leaderboard:', error)
    const errorMsg =
      error.response?.data?.message ||
      'Error deleting leaderboard. Please check the console.'
    alert(errorMsg)
  }
}

export const lbSections = [
  'Colleges',
  'College Subgroups',
  'High Schools',
  'High School Subgroups',
  'Companies',
  'Random',
]

export const fetchJoinedUsers = async (
  timePeriod,
  sortBy = '%return',
  page = 1,
  limit = 5,
  setLeaderboardData,
  filter = 'all',
  searchQuery = '',
  asc = false,
  userToken = null,
) => {
  try {
    const response = await axios.get(
      `${config.LBbackendUrl}/api/portfolios/top-portfolios-v1`,
      {
        params: {
          timePeriod,
          sortBy,
          page,
          limit,
          filter,
          searchQuery,
          asc,
          joined_filter: filter,
          joined_enabled: true
        },
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      }
    )

    // console.log('top-port: ',response.data.data)
    setLeaderboardData(response.data)
  } catch (error) {
    console.error('Error fetching leaderboard data:', error)
  }
}
